export default "__VITE_ASSET__BmNbz9if__"